import React, { useContext } from 'react';
import * as S from './styles';
import { MdDelete, MdEdit } from 'react-icons/md';
import { FaRegEye } from 'react-icons/fa';

import ListVerticalDragAndDrop from 'components/ListVerticalDragAndDrop';
import { formatDateBR, shrinkText } from 'utils/functions';
import { BlogProps } from 'types/BlogProps';
import { returnThumbYoutube } from 'utils/returnJSXs';
import Load from 'components/Load';
import { deleteBlogReq } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';

type ListBlogsProps = {
	blogs: BlogProps[];
	isLoad: boolean;
	setBlogs: React.Dispatch<React.SetStateAction<BlogProps[]>>;
	setBlogToEditOrSee: React.Dispatch<React.SetStateAction<BlogProps | null>>;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	setViewPreview: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ListBlogs({
	blogs,
	setBlogs,
	setBlogToEditOrSee,
	setIsOpenForm,
	setViewPreview,
	isLoad
}: ListBlogsProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);

	async function deleteBlog(id: string) {
		setIsOpenLoad(true);
		setMessage('Deletando blog...');

		const isSuccess = await deleteBlogReq(id);

		setIsOpenLoad(false);

		if (isSuccess) {
			const newList = blogs.filter((item) => item.id !== id);
			setBlogs(newList);
			handleNotify('Blog deletado com sucesso', 'success');
		} else {
			handleNotify('Erro ao deletar o blog', 'error');
		}
	}

	function ElementBlog(blog: BlogProps) {
		return (
			<S.blog>
				{returnThumbYoutube(blog?.urlVideo || '', blog?.title || '')}

				<S.infos>
					<p>
						<b>Título: </b>
						{blog?.title}
					</p>

					<S.htmlContent>
						<b>Subtítulo:</b>
						<p
							dangerouslySetInnerHTML={{
								__html: shrinkText(blog?.subtitle, 30)
							}}
						/>
					</S.htmlContent>

					<p>
						<b>Data: </b>
						{formatDateBR(blog?.date || '')}
					</p>
				</S.infos>

				<S.actions>
					<FaRegEye
						onClick={() => {
							setViewPreview(true);
							setBlogToEditOrSee(blog);
						}}
					/>
					<MdEdit
						onClick={() => {
							setIsOpenForm(true);
							setBlogToEditOrSee(blog);
						}}
					/>
					<MdDelete
						onClick={() => {
							deleteBlog(blog.id);
						}}
					/>
				</S.actions>
			</S.blog>
		);
	}

	return (
		<S.container>
			{isLoad ? (
				<S.centralizeLoad>
					<Load showText text="Buscando blogs" />
				</S.centralizeLoad>
			) : (
				<>
					{blogs.length === 0 ? (
						<S.emptyList>
							<p>Não há itens na lista</p>
						</S.emptyList>
					) : (
						<S.box>
							<ListVerticalDragAndDrop
								showBtnDrag
								setListItens={setBlogs}
								listItens={blogs}
								sizeIconDrag="2.5rem"
								returnItemList={(value: BlogProps) => ElementBlog(value)}
							/>
						</S.box>
					)}
				</>
			)}
		</S.container>
	);
}
